import api from "@/api/trading/apiTransact";
import { formatDecimal } from "@/utils/order";
import { selectedSymbolData } from "@/utils/symbol";
import axios from "axios";

export default {
  namespaced: true,
  state() {
    return {
      coinList: [],
      ticker: "BTC",
      orderType: "",
      orderInfo: {},
      reCode: 0,
      previousPrice: 0,
      lastPrice: 0,
      bidPrice: 0,
      askPrice: 0,
      liqPrice : 0,
      countryCode: "",
      isBitget: false,
      symbolData: {},
      allSymbolData: [],
      coinPrice: 0,
      sizeType: "USDT",
      symbolPriceInfo: {},
      orderbookInfo: {},
    };
  },
  mutations: {
    setCountryCode(state, payload) {
      state.countryCode = payload;
      // state.countryCode = "US";
      state.isBitget = ["US", "CN"].includes(state.countryCode);
    },
    setCoinList(state, payload) {
      state.coinList = payload;
    },
    setOrderInfo(state, payload) {
      const { type, ...orderInfo } = payload;
      state.orderType = type;
      state.orderInfo = orderInfo;
    },
    setReCode(state, payload) {
      state.reCode = payload;
    },
    setTicker(state, payload) {
      state.ticker = payload;
      localStorage.setItem("ticker", payload ? payload : "BTC");
    },
    setLastPrice(state, payload) {
      state.previousPrice = state.lastPrice;
      state.lastPrice = payload; //실시간 현재가
    },
    setDepthPrice(state, payload) {
      state.bidPrice = payload.bidPrice;
      state.askPrice = payload.askPrice;
    },
    setOrderbookInfo(state, payload) {
      state.orderbookInfo = payload;
    },
    setSizeType(state, payload) {
      state.sizeType = payload;
    },
    setSymbolData(state) {
      state.symbolData = selectedSymbolData(state.ticker);
    },
    setCoinPrice(state, payload) {
      state.coinPrice = parseFloat(payload);
    },
    setSymbolPriceInfo(state, payload) {
      state.symbolPriceInfo = payload;
    },
    setLiqPrice(state,payload){
      state.reCode = payload.reCode;
      state.liqPrice = payload.results?.liq_price;
    }
  },
  actions: {
    async fetchCoinList({ commit }) {
      try {
        const response = await api.getCoinList();
        if (response) {
          commit("setCoinList", response.tickers);
        }
      } catch (error) {
        return;
      }
    },
    async fetchPostLimitOrder({ state, commit }) {
      try {
        const queryString = new URLSearchParams(state.orderInfo).toString();
        const response = await api.postLimitOrder(state.orderType, queryString);
        commit("setReCode", response.reCode);
      } catch (error) {
        return;
      }
    },
    async fetchPostMarketOrder({ state, commit }) {
      try {
        let params;
        if (state.orderInfo?.price) {
          const { price, ...rest } = state.orderInfo;
          params = rest;
        } else {
          params = state.orderInfo;
        }
        const queryString = new URLSearchParams(params).toString();
        const response = await api.postMarketOrder(
          state.orderType,
          queryString
        );
        commit("setReCode", response.reCode);
      } catch (error) {
        return;
      }
    },
    async getSymbolPrecision({ state, commit }) {
      try {
        const symbol = `${state.ticker}USDT`;
        if (state.isBitget) {
          const response = await axios.get(
            `https://api.bitget.com/api/v2/mix/market/contracts?productType=usdt-futures`
          );
          state.allSymbolData = response?.data?.data;
        } else {
          const response = await axios.get(
            "https://fapi.binance.com/fapi/v1/exchangeInfo"
          );
          state.allSymbolData = response.data?.symbols;
        }
        commit("setSymbolData");
      } catch (error) {
        return;
      }
    },
    async getCoinPrice({ state, commit }) {
      const symbol = `${state.ticker}USDT`;
      if (state.isBitget) {
        const response = await axios.get(
          `https://api.bitget.com/api/v2/mix/market/ticker?productType=USDT-FUTURES&symbol=${symbol}`
        );
        const price = response.data.data[0].lastPr;
        commit("setCoinPrice", price);
      } else {
        const response = await axios.get(
          `https://fapi.binance.com/fapi/v1/ticker/price?symbol=${symbol}`
        );
        commit("setCoinPrice", response.data.price);
      }
    },
    async getSymbolPrice({ state, commit }) {
      const response = await api.getSymbolPrice(state.ticker);
      if (response) {
        commit("setSymbolPriceInfo", response.results[0]);
      }
    },
    async getCalculateLiqprice({ commit }, params) {
      const queryString = new URLSearchParams(params).toString();
      const response = await api.getCalculateLiqprice(queryString);
      if (response) {
        commit("setLiqPrice",response);
      }
    },
  },
  getters: {
    getTicker: (state) => state.ticker,
  },
};
